import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2, 3),
    backgroundColor: "#FFF",
    boxShadow: "0px 0px 25px rgba(0, 0, 0, 0.08) !important",
    position: "fixed",
    zIndex: 2,
  },
  rootLeft: {
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
    height: "100%",
    backgroundColor: "#FFFFFF",
    backgroundSize: "50px",
    zIndex: 2,
    },
  image: {
    width: theme.spacing(16),
    marginLeft: "8px",
    marginRight: "4px",
  },
  imageMarketing: {
    margin: theme.spacing(0, 2),
    width: theme.spacing(20),
  },
  btnOptions: {
    margin: `0 ${theme.spacing(1)} !important`,
    color: '#3C4762 !important',
    lineHeight: "20px !important",
    fontSize: "14px !important",
    fontWeight: "600 !important",
    borderRadius: '0px !important',
    height: "100%"
  },
  btn: {
    marginRight: `${theme.spacing(1)} !important`,
    lineHeight: "26px !important",
    height: "40px !important",
    borderRadius: '4.75rem !important',
    letterSpacing: '0.0px !important',
    "&:hover": {
      backgroundColor: "#f5f5f5",
      color: "black",
    },
  },
  btnStudio: {
    border: "1px solid !important",
  },
  avatar: {
    src:{
      width: "10px",
      height: "24px",
    },
  },
  sideBar: {
    position: "absolute",
    alignItems: "center",
  },
  wppImg: {
    marginRight: "8px"
  },
  content: {
    maxHeight: "92vh",
    overflowY: "auto",
    overflowX: "hidden",
    padding: 10,
    display: "blck",
    flex: 1,
    marginTop: "20px",
  }
}));
